import {
    SET_VIDEOS,
    SET_VIDEOS_LOADING,
    REMOVE_VIDEOS_LOADING,
    SET_VIDEO_FIELDS,
    SET_VIDEO_UPLOADING,
    REMOVE_VIDEO_UPLOADING
} from '../../types';

const initialState = {
    videos: [],
    videoFields: {
        video: null,
        name: null,
        description: null
    },
    loading: false,
    uploading: false
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_VIDEOS_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_VIDEOS_LOADING:
            return {
                ...state,
                loading: false
            };
        case SET_VIDEO_UPLOADING:
            return {
                ...state,
                uploading: true
            };
        case REMOVE_VIDEO_UPLOADING:
            return {
                ...state,
                uploading: false
            };
        case SET_VIDEOS:
            return {
                ...state,
                videos: payload
            };
        case SET_VIDEO_FIELDS:
            return {
                ...state,
                videoFields: { ...payload }
            };
        default:
            return state;
    }
}